import * as React from "react";
import shortid from "shortid";

function useId() {
  const id = React.useRef(shortid());

  return id.current;
}

export default useId;
